package org.zq.astrock_ai.ui.research.gushi

import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.sp
import org.zq.astrock_ai.theme.LocalAppFontFamily
import org.zq.astrock_ai.theme.appTypography
import org.zq.astrock_ai.theme.rememberAppFontFamily

object StockColors {
    val UpRed = Color(0xFFE53935)
    val StrongRed = Color(0xFFC62828)
    val UpSoft = Color(0xFFFFF1F1)

    val DownGreen = Color(0xFF16A34A)
    val StrongGreen = Color(0xFF137333)
    val DownSoft = Color(0xFFEDF9F0)

    val PrimaryBlue = Color(0xFF2563EB)
    val TextPrimary = Color(0xFF171A21)
    val TextSecondary = Color(0xFF68707D)
    val Border = Color(0xFFE7E9EE)
    val Background = Color(0xFFF5F6F8)
    val Card = Color(0xFFFFFFFF)
    val Neutral = Color(0xFF8A919E)
    val Orange = Color(0xFFF59E0B)
}

private val AppColorScheme = lightColorScheme(
    primary = StockColors.UpRed,
    onPrimary = Color.White,
    secondary = StockColors.PrimaryBlue,
    onSecondary = Color.White,
    background = StockColors.Background,
    onBackground = StockColors.TextPrimary,
    surface = StockColors.Card,
    onSurface = StockColors.TextPrimary,
    surfaceVariant = Color(0xFFF8F9FB),
    onSurfaceVariant = StockColors.TextSecondary,
    outline = StockColors.Border,
)

@Composable
fun GushiTheme(content: @Composable () -> Unit) {
    val fontFamily = rememberAppFontFamily()
    MaterialTheme(
        colorScheme = AppColorScheme,
        typography = appTypography(fontFamily),
        content = {
            // 覆盖外层 BinanceTheme 的近白 LocalContentColor，避免浅色底上白字看不清
            CompositionLocalProvider(
                LocalContentColor provides StockColors.TextPrimary,
                LocalTextStyle provides TextStyle(
                    fontFamily = fontFamily,
                    color = StockColors.TextPrimary,
                    fontSize = 14.sp,
                ),
                LocalAppFontFamily provides fontFamily,
            ) {
                content()
            }
        },
    )
}
